// tanstack
import { useParams } from '@tanstack/react-router';

// api
import { useGetEnergyGroupQuery } from '@/api/generated/recalc/endpoints/v2/energyGroups';
const useEnergyGroupUnit = () => {
  const { energyGroupId } = useParams({ strict: false });
  const { data: selectedEnergyGroup } = useGetEnergyGroupQuery(
    { groupId: energyGroupId },
    { skip: !energyGroupId },
  );

  const type = selectedEnergyGroup?.type || 'power';

  const unit = type.includes('Water') ? 'm³' : 'kWh';
  const effect = type.includes('Water') ? 'm³/h' : 'kW';
  return { unit, effect };
};

export default useEnergyGroupUnit;
